import { EstimatedDueDate } from '@/components/EstimatedDueDate/EstimatedDueDate';
import { getEstimatedDueAtDate, isArchived } from '@/models/article';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { ArticlePrice } from '../../ArticlePrice';

import { ArticleLocation } from './ArticleLocation';

export const ArticlePriceAndEstimatedDueDate = () => {
  const { view, article, iam } = useArticleContext();

  return (
    <>
      <ArticlePrice
        allowDiscount={
          view.prices.discount.client.shown &&
          !!article.taskType &&
          ['accept_dispatch', 'accept_requalification', 'choose_article_service'].includes(
            article.taskType
          )
        }
      />
      {!iam.hasOnlyExternalWorkshopScopeOnArticle && (
        <EstimatedDueDate
          variant="info"
          estimatedDate={isArchived(article) ? null : getEstimatedDueAtDate(article)}
        />
      )}
      <ArticleLocation />
    </>
  );
};
